var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8539 3.48642C12.7688 3.33889 12.6449 3.21605 12.4948 3.13056C12.3447 3.04507 12.1738 3 11.9999 3C11.8259 3 11.6551 3.04507 11.505 3.13056C11.3549 3.21605 11.2309 3.33889 11.1459 3.48642C10.9459 3.8403 10.7535 4.19872 10.5689 4.56167C9.98706 5.7098 9.4924 6.89775 9.08886 8.11604C8.94986 8.53505 8.53785 8.82574 8.06585 8.83838C6.63506 8.87495 5.20892 9.01304 3.79882 9.25157C3.02481 9.38379 2.73381 10.2413 3.28381 10.7643C3.40915 10.8842 3.53581 11.0025 3.66381 11.1192C4.62088 11.9979 5.63281 12.8184 6.69384 13.5759C7.06084 13.8374 7.21184 14.2856 7.07184 14.6959C6.53853 16.2544 6.15685 17.8581 5.93183 19.4859C5.83183 20.2199 6.63984 20.7381 7.34184 20.3881C8.7339 19.6942 10.065 18.8904 11.3219 17.9848C11.5187 17.8451 11.7562 17.7699 11.9999 17.7699C12.2436 17.7699 12.481 17.8451 12.6779 17.9848C13.9345 18.8908 15.2656 19.6946 16.6579 20.3881C17.3589 20.7381 18.1679 20.2199 18.0679 19.4859C18.0293 19.2105 17.9869 18.9366 17.9409 18.6644C17.7099 17.318 17.3712 15.9911 16.9279 14.6959C16.7879 14.2856 16.9379 13.8374 17.3059 13.5759C18.5097 12.7184 19.6492 11.7789 20.7159 10.7643C21.266 10.2413 20.9759 9.38379 20.2009 9.25157C18.791 9.01165 17.3648 8.87355 15.9339 8.83838C15.7077 8.83488 15.4881 8.76364 15.305 8.63438C15.1219 8.50511 14.9843 8.32411 14.9109 8.11604C14.3796 6.51256 13.6907 4.96156 12.8539 3.48642Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIco);
export default __webpack_public_path__ + "static/media/Star_ico.93bc0ed7f8cb655abd3f328c3b704a52.svg";
export { ForwardRef as ReactComponent };